jQuery(function ($) {
  $('.hero-carousel .slides').slick({
    infinite: false,
    draggable: false,
    speed: 500,
    prevArrow: '#hero-prev',
    nextArrow: '#hero-next',
    autoplay: true,
    autoplaySpeed: 4000,
    fade: true,
  });

  $('.caption .caption-number').each((index, element) => {
    $(element).click(function () {
      $('.hero-carousel .slides').slick('slickGoTo', index);
    });
  });

  $('.dot').each((index, element) => {
    $(element).click(function () {
      $('.hero-carousel .slides').slick('slickGoTo', index);
    });
  });

  $('.hero-carousel .slides').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    const mobileTitle = $('.collapse-horizontal div', $('.caption').eq(nextSlide)).text().trim();
    const mobileLink = $('.collapse-horizontal a', $('.caption').eq(nextSlide)).attr('href');

    $('.hero-carousel__mobile-title .hero-carousel__title').text(mobileTitle);
    if (mobileTitle) {
      $('.hero-carousel__mobile-title a').attr('href', mobileLink);
      $('.hero-carousel__mobile-title').removeClass('hide');
    } else {
      $('.hero-carousel__mobile-title a').attr('href', '');
      $('.hero-carousel__mobile-title').addClass('hide');
    }

    const title = $('.hero-carousel__overlay .hero-carousel__title');
    const currMedia = $('.media', $('.hero-carousel .slide').eq(nextSlide));
    if (currMedia.data('overlayTitle')) {
      title.removeClass('hero-carousel__title--hide');
    } else {
      title.addClass('hero-carousel__title--hide');
    }

    $('.dot').each((index, element) => {
      if (index === nextSlide) {
        $(element).addClass('active');
      } else {
        $(element).removeClass('active');
      }
    });

    $('.controls__captions .caption').each((index, element) => {
      if (index === nextSlide) {
        $(element).addClass('active');
      } else {
        $(element).removeClass('active');
      }
    });

    const collapse = $(`.controls__captions #collapse${nextSlide}`);
    collapse.horizontalCollapse('show');
  });

  $('.hero-carousel__pause').click(function () {
    $(this).toggleClass('paused');
    if ($(this).hasClass('paused')) {
      $('.hero-carousel .slides').slick('slickPause');
    } else {
      $('.hero-carousel .slides').slick('slickPlay');
    }
  });
});
